import { Box, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody } from '@chakra-ui/react';

import { Condition } from 'Component/others';
import { TextBold, TextMedium, TextRegular, TextSemiBold } from 'UiKit/typography';
import TableComponent from 'UiKit/table-component';

import useGetGiveawaySessionHistory from 'Domain/brief-live/useGetGiveawaySessionHistory';
import AttachmentImage from 'Component/attachment-image';
import DetailWinnerListSkeleton from 'View/brief-live/component/skeleton/modal/detail-winner-list';
import tableList from 'View/brief-live/section/detail-winner-list/const';
import { useBriefLiveState } from 'View/brief-live/state';
import { modalDetailWinnerText } from 'Const/brief-live/view';

import styles from './styles.module.css';

const DetailWinnerModal = () => {
  const { state, updateState } = useBriefLiveState();

  const { data, isFetching } = useGetGiveawaySessionHistory({
    id: state?.selectedGiveawayId,
    enabled: state?.isOpenModalDetailWinner,
  });

  const images = data?.imagePath ? [{ url: data?.imagePath }] : [];

  const handleCloseModal = () => {
    updateState({
      isOpenModalDetailWinner: false,
      selectedGiveawayId: null,
      ...(state.detailWinnerPreviousModal ? { [state.detailWinnerPreviousModal]: true } : {}),
      detailWinnerPreviousModal: null,
    });
  };

  const handleOpenPreview = (images) => {
    updateState({
      isOpenImagePreview: true,
      selectedImagePreview: images,
      isOpenModalDetailWinner: false,
      imagePreviewPreviousModal: 'isOpenModalDetailWinner',
    });
  };

  return (
    <Modal isOpen={state?.isOpenModalDetailWinner} onClose={handleCloseModal} isCentered>
      <ModalOverlay />
      <ModalContent minWidth={'983px'} maxHeight={'660px'}>
        <ModalHeader>
          <TextBold className={styles['modal__text--title']}>{modalDetailWinnerText.title}</TextBold>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody className={styles['modal__section--content']}>
          <Condition statement={!isFetching} fallback={<DetailWinnerListSkeleton />}>
            <Box className={styles['modal__section--giveaway']}>
              <Box className={styles['modal__section--giveaway-image']}>
                <AttachmentImage images={images} onOpenPreview={handleOpenPreview} />
              </Box>
              <Box className={styles['modal__section--giveaway-info']}>
                <TextSemiBold className={styles['modal__text--giveaway-name']}>{data?.productName}</TextSemiBold>
                <Box className={styles['modal__row--giveaway']}>
                  <Box className={styles['modal__column--brand']}>
                    <TextRegular className={styles['modal__text--label']}>{modalDetailWinnerText.brand}</TextRegular>
                    <TextMedium className={styles['modal__text--value']}>{data?.brand}</TextMedium>
                  </Box>
                  <Box className={styles['modal__column--stock']}>
                    <TextRegular className={styles['modal__text--label']}>{modalDetailWinnerText.stock}</TextRegular>
                    <TextMedium className={styles['modal__text--value']}>{data?.totalStock}</TextMedium>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box className={styles['modal__section--giveaway-list']}>
              <TableComponent
                columns={tableList(handleOpenPreview)}
                dataSource={data?.sessionHistories}
                isDataExist={!isFetching && data?.sessionHistories?.length > 0}
                rowHeight="fit-content"
                paddingBodyBox="20px 12px"
                maxTableBodyHeight="384px"
                verticalAlignBody="top"
              />
            </Box>
          </Condition>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default DetailWinnerModal;
